@if (loadingBarService.isShowing) {
<p-progressbar [color]="loadingBarService.color" [mode]="loadingBarService.mode" [style]="{ height: '4px' }" [value]="loadingBarService.progress" />
}
